export enum Role {
  OWNER = 0,
  ADMIN = 1,
  MEMBER = 2,
}
